import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './component/ProtectedRoute';
import Homepage from './component/Homepage';
import Loginpage from './component/Loginpage';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '@fortawesome/fontawesome-free/css/all.min.css';



function App() {
  return (
    <>
     <ToastContainer position="top-right" autoClose={3000} />
    <BrowserRouter>
   
    <Routes>
     <Route path='/' element={<Loginpage/>} />
       <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Homepage/>
            </ProtectedRoute>
          }
        />
       

      </Routes>
   </BrowserRouter>
      
    </>
  );
}

export default App;
